module.exports = __webpack_public_path__ + "img/yzz.31b99ad.png";